module.exports = "/next-static/_next/static/images/oneStreamMultipleDestinations-cac16cd1aba4c473ce57496ece99dd7e.png";